import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { roles } from "./Utils/constants";
import SidebarClient from "./Pages/Dashboard/components/Sidebar";
import SidebarConsultant from "./Pages/DashboardConsultant/components/Sidebar";
import SidebarVendor from "./Pages/DashboardVendor/components/Sidebar";
import { useCommonNotificationProvider } from "./Providers/Common/Notification";
import Header from "./Pages/CombinedDashboard/Header";
import { Outlet } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import ClearAllRoundedIcon from "@mui/icons-material/ClearAllRounded";
import moment from "moment";
import api from "./Utils/api";

export default function Holder() {
  const [path, setPath] = useState([]);
  const [profile, setProfile] = useState(null);
  const [notificationVisible, setNotificationVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { getNewNotifications, loading, notifications, markAsRead } =
    useCommonNotificationProvider();
  const isSignedIn = useSelector((state) => state.user.value);
  const role = useSelector((state) => state.user.role);
  const accessToken = useSelector((state) => state.token.value);
  const permissions = useSelector((state) => state.user.permissions);
  useEffect(() => {
    api.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
    if(permissions.includes(`admin-${role.toLowerCase()}`)){
      getNewNotifications();
    }
    const interval = setInterval(() => getNewNotifications(), 100000);
    return () => {
      clearInterval(interval);
    };
  }, [refresh]);

  const markNotificationAsRead = (id) => {
    console.log(id);
    markAsRead(id);
    setRefresh(!refresh);
  };

  const action = (notification) => {
    markAsRead([notification?.id]);
    setRefresh(!refresh);
    setNotificationVisible(!notificationVisible);
    if (notification.action_link.split(" ")[0] === "ViewTimesheet") {
      window.location.href = "/dashboard/timesheetscard";
      setNotificationVisible(!notificationVisible);
    } else if (
      notification.action_link.split(" ")[0] === "ViewConnectionsClient"
    ) {
      window.location.href = "/dashboard/clients";
    } else if (
      notification.action_link.split(" ")[0] === "ViewConnectionsVendor"
    ) {
      window.location.href = "/dashboard/vendors";
    } else if (
      notification.action_link.split(" ")[0] === "ViewConnectionsConsultant"
    ) {
      window.location.href = "/dashboard/consultants";
    } else if (notification.action_link.split(" ")[0] === "ViewInvoice") {
      window.location.href = "/dashboard/invoices";
    } else if (notification.action_link.split(" ")[0] === "ViewJob") {
      if (role === roles.client) {
        window.location.href = "/dashboard/jobs";
      } else if (role === roles.vendor) {
        window.location.href = "/dashboard/jobs";
      } else if (role === roles.consultant) {
        window.location.href = "/dashboard/myjobs";
      }
    } else if (notification.action_link.split(" ")[0] === "EditProfile") {
      window.location.href = "/dashboard/myaccount";
    }
  };

  return (
    <div>
      <Header
        setNotificationVisible={setNotificationVisible}
        notificationVisible={notificationVisible}
        notificationCount={notifications.length}
      />
      <div className="overflow-y-clip">
        <div class="h-screen flex">
          <div class="bg-gray-600 w-[270px] no-scrollbar">
            {isSignedIn &&
              (role === roles.client ? (
                <SidebarClient />
              ) : role === roles.vendor ? (
                <SidebarVendor />
              ) : (
                <SidebarConsultant />
              ))}
          </div>
          <div class="flex-1 flex overflow-y-clip">
            <div class="flex-1 overflow-y-scroll">
              <div>
                <main class=" bg-neutral-100">
                  <div className="border-gray-300 p-8 min-h-screen">
                    <Outlet context={setPath} />
                  </div>
                </main>
              </div>
            </div>
          </div>
          <div
            className={`w-full h-full bg-gray-800 bg-opacity-50 top-0 overflow-y-auto overflow-x-hidden fixed sticky-0 ${
              notificationVisible ? "" : "hidden"
            } `}
            id="chec-div"
          >
            <div
              class="w-1/4 absolute z-10 right-0 h-full overflow-x-hidden transform translate-x-0 transition ease-in-out duration-700"
              id="notification"
            >
              <div class="2xl:w-4/12 bg-gray-50 h-screen overflow-y-auto p-8 absolute right-0 no-scrollbar">
                <div class="flex items-center justify-between">
                  <p
                    tabindex="0"
                    class="focus:outline-none text-2xl font-semibold leading-6 text-gray-800"
                  >
                    Notifications
                  </p>
                  <button
                    role="button"
                    aria-label="close modal"
                    class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 rounded-md cursor-pointer"
                    onClick={(e) =>
                      setNotificationVisible(!notificationVisible)
                    }
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 6L6 18"
                        stroke="#4B5563"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M6 6L18 18"
                        stroke="#4B5563"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                {loading ? (
                  <div class="flex items-center justiyf-between">
                    <hr class="w-full" />
                    <p
                      tabindex="0"
                      class="focus:outline-none text-sm flex flex-shrink-0 leading-normal px-28 py-16 text-gray-500"
                    >
                      <CircularProgress />
                    </p>
                    <hr class="w-full" />
                  </div>
                ) : !loading && notifications.length === 0 ? (
                  <div class="flex items-center justiyf-between">
                    <hr class="w-full" />
                    <p
                      tabindex="0"
                      class="focus:outline-none text-sm flex flex-shrink-0 leading-normal px-28 py-16 text-gray-500"
                    >
                      No new notifications
                    </p>
                    <hr class="w-full" />
                  </div>
                ) : (
                  notifications.map((notification, index) => {
                    return (
                      <div class="p-4 mt-4 bg-white rounded shadow flex flex-shrink-0 hover:shadow-md">
                        <div
                          key={notification?.id}
                          tabindex="0"
                          aria-label="group icon"
                          role="img"
                          class="focus:outline-none w-8 h-8 border rounded-full border-gray-200 flex flex-shrink-0 items-center justify-center"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.33325 14.6667C1.33325 13.2522 1.89516 11.8956 2.89535 10.8954C3.89554 9.89523 5.2521 9.33333 6.66659 9.33333C8.08107 9.33333 9.43763 9.89523 10.4378 10.8954C11.438 11.8956 11.9999 13.2522 11.9999 14.6667H1.33325ZM6.66659 8.66666C4.45659 8.66666 2.66659 6.87666 2.66659 4.66666C2.66659 2.45666 4.45659 0.666664 6.66659 0.666664C8.87659 0.666664 10.6666 2.45666 10.6666 4.66666C10.6666 6.87666 8.87659 8.66666 6.66659 8.66666ZM11.5753 10.1553C12.595 10.4174 13.5061 10.9946 14.1788 11.8046C14.8515 12.6145 15.2515 13.6161 15.3219 14.6667H13.3333C13.3333 12.9267 12.6666 11.3427 11.5753 10.1553ZM10.2266 8.638C10.7852 8.13831 11.232 7.52622 11.5376 6.84183C11.8432 6.15743 12.0008 5.41619 11.9999 4.66666C12.0013 3.75564 11.7683 2.85958 11.3233 2.06466C12.0783 2.21639 12.7576 2.62491 13.2456 3.2208C13.7335 3.81668 14.0001 4.56315 13.9999 5.33333C14.0001 5.80831 13.8987 6.27784 13.7027 6.71045C13.5066 7.14306 13.2203 7.52876 12.863 7.84169C12.5056 8.15463 12.0856 8.38757 11.6309 8.52491C11.1762 8.66224 10.6974 8.7008 10.2266 8.638Z"
                              fill="#047857"
                            />
                          </svg>
                        </div>
                        <div class="pl-3 w-full">
                          <div class="flex items-center justify-between w-full">
                            <p
                              tabindex="0"
                              class="focus:outline-none text-sm leading-none cursor-pointer"
                              onClick={(e) => {
                                action(notification);
                              }}
                            >
                              {notification?.notification_message}
                            </p>
                            <div
                              tabindex="0"
                              aria-label="close icon"
                              role="button"
                              class="focus:outline-none cursor-pointer pl-2 text-right"
                            >
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={(e) => {
                                  markNotificationAsRead([notification?.id]);
                                }}
                              >
                                <path
                                  d="M10.5 3.5L3.5 10.5"
                                  stroke="#4B5563"
                                  stroke-width="1.25"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M3.5 3.5L10.5 10.5"
                                  stroke="#4B5563"
                                  stroke-width="1.25"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                          </div>
                          <p
                            tabindex="0"
                            class="focus:outline-none text-xs leading-3 pt-2 text-gray-500"
                          >
                            {moment(notification?.createdAt).fromNow()}
                          </p>
                        </div>
                      </div>
                    );
                  })
                )}
                <br />
                {!loading && notifications.length > 0 ? (
                  <div className="text-right">
                    <ClearAllRoundedIcon
                      onClick={(e) => {
                        markNotificationAsRead(
                          notifications.map((notification) => notification?.id)
                        );
                      }}
                      className="cursor-pointer"
                      fontSize="medium"
                      style={{ color: "#4B5563" }}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
